<template>
  <div>
    <div class="row gutter-sm" v-for="(email, index) in emailAddresses" :key="index">
      <div :class="[emailAddressesNotEmpty ? 'col-11' : 'col-12']">
        <email-input
          @input="updateEmail($event, index)"
          :value="emailAddresses[index]"
          :id="index"
          :label="label"
          :hideLabel="hideLabel"
          :showIcon="showIcon"
        />
      </div>

      <div v-show="emailAddressesNotEmpty" class="col-1 text-right">
        <q-btn flat dense icon="remove_circle" color="light" class="q-mt-lg" @click="clearEmail(index)"/>
      </div>
    </div>
    <div class="row justify-end">
      <q-btn flat dense
             v-show="emailAddressesNotEmpty"
             @click="addEmailAddress"
             :label="$t('additional_email_address')"
             :class="showControls ? 'q-mr-xl' : ''"
      />
    </div>
  </div>
</template>

<script>
  import CustomerEmailAddress from 'src/utils/SubResources/CustomerEmailAddress'
  import EmailInput from './EmailInput.vue'
  import { isEqual } from 'lodash'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: Array,
        required: true
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the email line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        emailAddresses: this.value
      }
    },

    computed: {
      showControls () {
        return this.emailAddresses.length > 1
      },

      emailAddressesNotEmpty () {
        return !this.isEmptyEmail(this.emailAddresses[0])
      }
    },

    methods: {
      updateEmail (value, index) {
        this.emailAddresses.splice(index, 1, value)

        this.createDefaultEmailAddress()

        this.emitEmails()
      },

      addEmailAddress () {
        this.emailAddresses.push(CustomerEmailAddress.empty())
      },

      createDefaultEmailAddress () {
        if (this.emailAddresses.length === 0) {
          this.addEmailAddress()
        }
      },

      clearEmail (index) {
        this.emailAddresses.splice(index, 1)
      },

      showRemoveButton (index) {
        return index < this.emailAddresses.length - 1
      },

      isEmptyEmail (email) {
        return isEqual(email, CustomerEmailAddress.empty())
      },

      emitEmails () {
        this.$emit('input', this.emailAddresses)
      }
    },

    created () {
      this.createDefaultEmailAddress()
    },

    watch: {
      value: {
        handler: function (newEmailAddresses) {
          this.emailAddresses = newEmailAddresses

          this.createDefaultEmailAddress()
        },
        deep: true
      }
    },

    components: {
      EmailInput
    }
  }
</script>
